import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'avatarImage'
})
export class AvatarImagePipe implements PipeTransform {

  transform(value: string): string {
    if (value && value !== '') {
      return `url(${value})`;
    }

    return 'none';
  }

}
